import React, { useState } from "react"
import { StyleSheet, TextInput as NativeTextInput } from "react-native"
import { TextInput } from "react-native-paper"
import { baseColors } from "@Constants/baseStyles"

const CommentInput = (props) => {
    const { setDisableBtn, message, setMessage, disabled } = props
    const [isFocused, setIsFocused] = useState(false)
    const [value, setValue] = useState(message)
    const hanleSetValue = (text) => {
        setValue(text)
        setMessage(text)
        setDisableBtn?.(text?.trim() === "")
    }

    return (
        <TextInput
            disabled={disabled}
            multiline
            autoFocus
            value={value}
            onChangeText={(txt) => hanleSetValue(txt)}
            placeholder={props.placeholder || "Tapez votre texte"}
            textAlignVertical={"top"}
            onEndEditing={(e) => setMessage(value)}
            render={(innerProps) => (
                <NativeTextInput
                    placeholderTextColor={baseColors.grey}
                    placeholder={props.placeholder || "Tapez votre texte"}
                    {...innerProps}
                    style={{
                        ...styles.textInput,
                        height: props.height || 195
                    }}
                />
            )}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            theme={{
                roundness: 10,
                colors: {
                    text: baseColors.green.primary,
                    primary: props.defaultPrimaryColor ?? baseColors.orange.primary,
                    background: props.defaultPrimaryColor || !isFocused ? baseColors.white : baseColors.orange.light
                }
            }}
            mode="outlined"
        />
    )
}

export { CommentInput }

const styles = StyleSheet.create({
    textInput: { color: baseColors.green.dark, paddingHorizontal: 8, paddingTop: 8, paddingBottom: 8 }
})
